import React from "react";
import "./Footer.css";
export default function Footer() {
  return (
    <footer>
      <div class="footer-content">
        <p>&copy; 2023 All rights reserved.</p>
        {/* <ul class="footer-links">
          <li>
            <a href="#">Home</a>
          </li>
          <li>
            <a href="#">About</a>
          </li>
          <li>
            <a href="#">Services</a>
          </li>
          <li>
            <a href="#">Contact</a>
          </li>
        </ul> */}
      </div>
    </footer>
  );
}
